import React, { useState } from 'react';
import { Card, Form, Badge } from 'react-bootstrap';

export default function ProfileNotificationsComp({ profile }) {
    console.log("ProfileNotificationsComp profile:", profile);
    const upcomingTours = profile?.upcoming_tours || [];

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' at ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (<>
        <div className='tab-header'>
            <h2>Upcoming Tours</h2>
            <p>View your scheduled property tours</p>
        </div>

        <Card className="tab-box">
            <div className="tab-box-wrap">
                <h5>Scheduled Tours</h5>

                {upcomingTours.length === 0 ? (
                    <div className="text-center py-4">
                        <p className="text-muted">No upcoming tours scheduled</p>
                    </div>
                ) : (
                    upcomingTours.map((tour) => (
                        <div key={tour.id} className="tour-item mb-4 p-3 border rounded">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="mb-1">{tour.property_name}</h6>
                                <Badge
                                    bg={tour.status === 'confirmed' ? 'success' : 'warning'}
                                    className="text-capitalize text-white"
                                >
                                    {tour.status}
                                </Badge>
                            </div>

                            <div className="tour-details">
                                <div className="mb-1">
                                    <strong>Agent:</strong> {tour.agent_first_name} {tour.agent_last_name}
                                </div>
                                <div className="mb-1">
                                    <strong>Date & Time:</strong> {formatDateTime(tour.start_time)}
                                </div>
                                <div className="mb-1">
                                    <strong>Agent Contact:</strong> {tour.agent_email} | {tour.agent_phone}
                                </div>
                                {tour.message && (
                                    <div className="mb-1">
                                        <strong>Your Message:</strong> {tour.message}
                                    </div>
                                )}
                                {tour.wants_financing_info && (
                                    <div className="mb-1">
                                        <Badge bg="info text-white">Interested in financing</Badge>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </Card>
    </>
    );
}
